import {
    FILING_STATUS,
    ELECTRONIC_FILING_STATUS
} from '../../../services/constant/constant';

export class Filings {
    static getElectronicFilingStatusName(electronicFilingStatusEnum) {
        switch (electronicFilingStatusEnum) {
            case ELECTRONIC_FILING_STATUS.SUCCESS:
                return 'Success';
            case ELECTRONIC_FILING_STATUS.FAILED:
                return 'Failed';
            case ELECTRONIC_FILING_STATUS.NOT_SUBMITTED:
            default:
                return 'Not Submitted';
        }
    }

    static getFilingStatusName(filingStatusEnum) {
        switch (filingStatusEnum) {
            case FILING_STATUS.NOT_FILED:
                return 'Not Filed';
            case FILING_STATUS.PENDING:
                return 'Pending';
            case FILING_STATUS.APPROVED:
                return 'Filed';
            case FILING_STATUS.DENIED:
                return 'Cancelled';
            case FILING_STATUS.IN_PROGRESS:
                return 'In Progress';
            case FILING_STATUS.ON_HOLD:
                return 'Client Hold';
            case FILING_STATUS.CLIENT_CANCELLED:
                return 'Client Cancelled';
            case FILING_STATUS.EXEMPTION_APPROVED:
                return 'Exemption Approved';
            case FILING_STATUS.EXEMPTION_QUERIED:
                return 'Exemption Queried';
            case FILING_STATUS.AMENDMENT:
                return 'Amendment';
            case FILING_STATUS.HOLD_FOR_PAYMENT:
                return 'Hold';
            case FILING_STATUS.READY_FOR_RENEWAL:
                return 'Renewal';
            case FILING_STATUS.TERMINATED:
                return 'Terminated';
            case FILING_STATUS.FILING_SENT:
                return 'Filing Sent';
            default:
                return '';
        }
    }
}



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/services/Filings.js